import { call, takeLatest, put, select, fork } from 'redux-saga/effects'

// import { api } from 'Redux/services'
// import { parsePayloadForShape } from 'Utils/searchFilterUtils'
import { getLocationQuery } from 'Modules/location/selectors'

// import { SUCCESS } from '../../actions/constants'
import StoryblokService from 'Utils/storyblokUtils'
import {
  LOAD_SB_POST,
  getSBPostAction,
  LOAD_SB_CATEGORY,
  getSBCategoryAction,
  getSBAuthorAction,
  getSBFeaturedAction,
  getSBCategoriesAction,
  getSBPostListByGroupAction,
  LOAD_SB_HOME,
  getSBRelatedPostsAction,
  LOAD_SB_RELATED_POSTS,
  LOAD_SB_POST_LIST_BY_CAT,
  RELOAD_SB_LATEST_POSTS,
  getSBBlogHomeAction,
  // getSBMostPopularPostsAction,
  getSBLatestPostsAction,
  // getPopularPostIds,
} from './actions'
// //////

export function* fetchStoryblok({ slug, reduxActions, pageNumber }) {
  const siteLocationQuery = yield select(getLocationQuery)
  StoryblokService.setQuery(siteLocationQuery)
  const newSlug = slug
  try {
    yield put(reduxActions.request({ page: pageNumber }))
    const res = yield call(StoryblokService.getAsync, newSlug)
    yield put(reduxActions.success(null, res))
  } catch(e) {
    yield put(reduxActions.failure())
  }
}

// load post page data
export function* loadStoryblokPost({ storyId }) {
  const storyblokSlug = `cdn/stories/${storyId}?resolve_relations=post.primary_category,author,categories`
  yield fork(fetchStoryblok, { slug: storyblokSlug, reduxActions: getSBPostAction })

  // fetch all categories for home page
  const allCategoriesSlug = 'cdn/stories?starts_with=blog/categories&resolve_links=url'
  yield fork(fetchStoryblok, { slug: allCategoriesSlug, reduxActions: getSBCategoriesAction })
}

// load post list based on page number and category
export function* loadStoryblokPostListByCat({ categoryUuid, pageNum }) {
  // To exclude the featured post from list of posts
  const categoryFeaturedPost = yield select(state => state.storyblok.featuredPost)
  const categoryFeaturedPostId = categoryFeaturedPost && categoryFeaturedPost.id

  // fetch category featured post data
  const siteLocationQuery = yield select(getLocationQuery)
  const categoryPostListSlug = 'cdn/stories?starts_with=blog/posts&sort_by=content.date:desc:date' +
    '&resolve_relations=categories' +
    `&per_page=6&filter_query[categories][exists]=${categoryUuid}` +
    `${pageNum || siteLocationQuery.page ? '&page=' + (pageNum || siteLocationQuery.page) : ''}` +
    `${categoryFeaturedPostId ? '&excluding_ids=' + categoryFeaturedPostId : ''}`

  yield call(fetchStoryblok, { slug: categoryPostListSlug, reduxActions: getSBPostListByGroupAction })
}

// load post list based on page number and author
export function* loadStoryblokPostListByAuthor({ authorUuid, pageNum }) {
  // To exclude the featured post from list of posts
  const authorFeaturedPost = yield select(state => state.storyblok.featuredPost)
  const authorFeaturedPostId = authorFeaturedPost && authorFeaturedPost.id

  // fetch category featured post data
  const siteLocationQuery = yield select(getLocationQuery)
  const authorPostListSlug = 'cdn/stories?starts_with=blog/posts&sort_by=content.date:desc:date' +
    '&resolve_relations=categories' +
    `&per_page=6&filter_query[author][in]=${authorUuid}` +
    `${pageNum || siteLocationQuery.page ? '&page=' + (pageNum || siteLocationQuery.page) : ''}` +
    `${authorFeaturedPostId ? '&excluding_ids=' + authorFeaturedPostId : ''}`

  yield call(fetchStoryblok, { slug: authorPostListSlug, reduxActions: getSBPostListByGroupAction })
}

// load category page data
export function* loadStoryblokCategory({ storyId, categoryUuid }) {
  // fetch category page data
  const categorySlug = `cdn/stories/${storyId}`
  yield fork(fetchStoryblok, { slug: categorySlug, reduxActions: getSBCategoryAction })

  // fetch category featured post data
  const featuredPostSlug = 'cdn/stories?starts_with=blog/posts&sort_by=content.date:desc:date' +
    `&filter_query[categories][exists]=${categoryUuid}` +
    '&filter_query[home_page_featured][in]=true&per_page=1&resolve_relations=author,categories'
  // use call to fetch and wait for featured post and then exclude it from list of posts in section below featured
  yield call(fetchStoryblok, { slug: featuredPostSlug, reduxActions: getSBFeaturedAction })

  // load list of category posts with pagination
  yield fork(loadStoryblokPostListByCat, { categoryUuid })


  // fetch all categories for category page
  const allCategoriesSlug = 'cdn/stories?starts_with=blog/categories&resolve_links=url'
  yield fork(fetchStoryblok, { slug: allCategoriesSlug, reduxActions: getSBCategoriesAction })
}


// load author page data
export function* loadStoryblokAuthor({ storyId, authorUuid }) {
  // fetch category page data
  const authorSlug = `cdn/stories/${storyId}`
  yield fork(fetchStoryblok, { slug: authorSlug, reduxActions: getSBAuthorAction })

  // fetch category featured post data
  const featuredPostSlug = 'cdn/stories?starts_with=blog/posts&sort_by=content.date:desc:date' +
    `&filter_query[author][in]=${authorUuid}` +
    '&filter_query[home_page_featured][in]=true&per_page=1&resolve_relations=author,categories'
  // use call to fetch and wait for featured post and then exclude it from list of posts in section below featured
  yield call(fetchStoryblok, { slug: featuredPostSlug, reduxActions: getSBFeaturedAction })

  // load list of category posts with pagination
  yield fork(loadStoryblokPostListByAuthor, { authorUuid })


  // fetch all categories for category page
  const allCategoriesSlug = 'cdn/stories?starts_with=blog/categories&resolve_links=url'
  yield fork(fetchStoryblok, { slug: allCategoriesSlug, reduxActions: getSBCategoriesAction })
}


// fetch storyblok pages' data on SSR based on page type
export function* loadStoryblokPage({ urlParametersObj }) {
  const { component, story_id: storyId, uuid } = urlParametersObj
  switch(component) {
    case 'post':
      yield call(loadStoryblokPost, { storyId })
      break
    case 'category':
      yield call(loadStoryblokCategory, { storyId, categoryUuid: uuid })
      break
    case 'author':
      yield call(loadStoryblokAuthor, { storyId, authorUuid: uuid })
      break
  }
}

// //////////////////////////////////////////////////////////////////////////////////////
// const apiPopularPostIds = () => api.callApi('storyblok/popular-blogs', {
//   mode: 'GET',
// })
//
// function* fetchPopularPosts() {
//   /*
//   * initially, it was taking POPULAR_POST_IDS_API[SUCCESS] but it never trigger saga
//   * even thought it goes through redux. Therefore, it directly getting result here and handle it
//   * */
//   const { response, error } = yield call(apiPopularPostIds)
//   const data = response.data
//   if(data && data.status) {
//     const responseMessage = data && data.message
//     if(responseMessage === 'success') {
//       const uuids = data.data && data.data.uuids
//       const uuidsString = uuids && uuids.join(',')
//       if(uuidsString) {
//         // load storyblok posts by uuids
//         const mostPopularPostsSlug = `cdn/stories?by_uuids_ordered=${uuidsString}` +
//                                      '&per_page=4&sort_by=content.date:desc:date'
//         yield fork(fetchStoryblok, { slug: mostPopularPostsSlug, reduxActions: getSBMostPopularPostsAction })
//       }
//     }
//   } else {
//     yield put(getPopularPostIds.failure(null, error))
//   }
// }

// //////////////////////////////////////////////////////////////////////////////////////

// //////////////////////////////////////////////////////////////////////////////////////
function* loadStoryblokRelatedPosts(action) {
  const { categories } = action
  const relatedPostsListSlug = 'cdn/stories?starts_with=blog/posts&sort_by=content.date:desc:date' +
      '&resolve_relations=categories' +
      `&per_page=20&filter_query[categories][in_array]=${categories}`
  yield call(fetchStoryblok, { slug: relatedPostsListSlug, reduxActions: getSBRelatedPostsAction })
}
// //////////////////////////////////////////////////////////////////////////////////////


// //////////////////////////////////////////////////////////////////////////////////////
function* reloadStoryblokLatestPosts(action) {
  const { page } = action
  let latestPostsSlug = 'cdn/stories?starts_with=blog/posts&sort_by=content.date:desc:date' +
   '&per_page=2&resolve_relations=author,categories'
  if(page) latestPostsSlug += `&page=${page}`
  yield fork(fetchStoryblok, {
    slug: latestPostsSlug,
    reduxActions: getSBLatestPostsAction,
    pageNumber: page,
  })
}
// //////////////////////////////////////////////////////////////////////////////////////


// load Storyblok home page data
export function* loadStoryblokHome() {
  // fetch Storyblok home page data
  const blogHomeSlug = 'cdn/stories/blog?resolve_relations=tips_and_news.posts,popular_posts.posts'
  yield fork(fetchStoryblok, { slug: blogHomeSlug, reduxActions: getSBBlogHomeAction })

  // fetch home featured post data
  const featuredPostSlug = 'cdn/stories?starts_with=blog/posts&sort_by=content.date:desc:date' +
   '&filter_query[home_page_featured][in]=true&per_page=1&resolve_relations=author,categories'
  yield fork(fetchStoryblok, { slug: featuredPostSlug, reduxActions: getSBFeaturedAction })


  // fetch home most popular posts data
  // yield call(fetchPopularPosts)
  // fetch home latest posts data

  let latestPostsSlug = 'cdn/stories?starts_with=blog/posts&sort_by=content.date:desc:date' +
   '&per_page=2&resolve_relations=author,categories'
  const lastSearchObj = yield select(state => state.location.lastSearchObj)
  if(lastSearchObj.page) latestPostsSlug += `&page=${lastSearchObj.page}`
  yield fork(fetchStoryblok, {
    slug: latestPostsSlug,
    reduxActions: getSBLatestPostsAction,
    pageNumber: lastSearchObj.page,
  })


  // fetch all categories for home page
  const allCategoriesSlug = 'cdn/stories?starts_with=blog/categories&resolve_links=url'
  yield fork(fetchStoryblok, { slug: allCategoriesSlug, reduxActions: getSBCategoriesAction })
}

export function* watchStoryblok() {
  yield takeLatest(LOAD_SB_POST, loadStoryblokPost)
  yield takeLatest(LOAD_SB_CATEGORY, loadStoryblokCategory)
  yield takeLatest(LOAD_SB_HOME, loadStoryblokHome)
  yield takeLatest(LOAD_SB_RELATED_POSTS, loadStoryblokRelatedPosts)

  yield takeLatest(LOAD_SB_POST_LIST_BY_CAT, loadStoryblokPostListByCat)
  yield takeLatest(RELOAD_SB_LATEST_POSTS, reloadStoryblokLatestPosts)
}
